import React, {useEffect, useState} from "react";
import {useIntl} from 'react-intl';
import {useSelector} from 'react-redux';
import { useRealtimeUnits } from 'Core/hooks';

// Components
import {Form, Pill, ToggleSwitch} from 'Components';
import {Grid} from '@mui/material';
import Slider from '../../../../../../../../components/Slider';
import {useGetOdometerUserValues} from '../../../../../../../../modules/.common/hooks/userPreferenceHooks'
import TriggerLandmark from "Modules/alerts/components/wizardAlert/common/components/TriggerLandmark";
import {NotificationManager} from "Components/Notifications";


export const Speed = (props) => {

    const { value, triggers, triggersRaw, onChange, formRef } = props
    const { messages } = useIntl()
    const units = useRealtimeUnits({ trackFields: ['id', 'name', 'label', 'disabled', 'driverId', 'vehicleStatusId', 'tags'] });
    
    const [getOdometerUnitValue, odometerMeasure] = useGetOdometerUserValues()
    const [triggerSpeed, setTriggerSpeed] = useState(getOdometerUnitValue(3))
    const [triggerPostedSpeed, setTriggerPostedSpeed] = useState(0)
    const [triggerPostedSpeedOem, setTriggerPostedSpeedOem] = useState(0)
    const [operatorAnd, setOperatorAnd] = useState("True")
    const [showErrorTrigger, setShowErrorTrigger] = useState(false)

    useEffect(() => {
        if (value.triggerSpeed == undefined)
            onChange({
                ...value,
                triggerSpeed: 3,
                triggerPostedSpeed: value?.triggerPostedSpeed || 0,
                triggerOEMSpeeding:triggerPostedSpeedOem?true: false,
                operatorAnd: value?.operatorAnd == undefined ? "True" : value?.operatorAnd
            })
        else {
            setTriggerSpeed(getOdometerUnitValue(value.triggerSpeed))
            setTriggerPostedSpeed(getOdometerUnitValue(value.triggerPostedSpeed))
            setTriggerPostedSpeedOem(value?.triggerOEMSpeeding || 0)
            setOperatorAnd(value.operatorAnd || "True")
        }
    }, [value])

    // <---- Entity Selector Setup ---->
    const entities = [
        { id: "Landmark", label: "Landmarks" },
        { id: "All", label: "All" },
    ];

    // Default selected landmarkGroups
    const [withLandMarks, setWithLandMarks] = useState((triggers?.length > 0 || triggersRaw?.length > 0) ? true : false);

    const isValidRequiredItems = (clickNext = false) => {
        let isValid = false
        if (triggerSpeed > 0)
            isValid = true
        if (triggerPostedSpeed > 0)
            isValid = true

        if (value.trigger && clickNext) {
            isValid = triggersRaw?.length > 0

            if (!isValid) {
                setShowErrorTrigger(true)
            }  else setShowErrorTrigger(false)
        }
        return isValid
    }

    return (
        <Form ref={formRef}
            onSubmit={() => {
                if (value.trigger) {
                    let isValid = triggersRaw?.length > 0

                    if (!isValid) {
                        setShowErrorTrigger(true)
                    } else setShowErrorTrigger(false)
                    return isValid
                }
                return true
            }}
        >
            {
                //value.triggerSpeed != undefined &&
                <div className="form-item">
                    <label className="input-normal-label">{messages['alertsNewAlert_triggersLabel']}</label>
                    {
                        (!isValidRequiredItems()) &&
                        <div className="text-danger">
                            {messages["alertsNewAlert_triggerValidation"]}
                        </div>
                    }

                    <div style={{ paddingTop: "20px", width: "100%" }}>
                        <ToggleSwitch
                            id="triggerSpeed"
                            small
                            blueToggle
                            optionLabels={["", ""]}
                            label={messages['alertsNewAlert_vehicleSpeed']}
                            checked={(triggerSpeed > 0) ? true : false}
                            onChange={(event) => {
                                const newSpeed = event ? 3 : 0
                                setTriggerSpeed(newSpeed)
                                const newOperator = !event ? "True" : operatorAnd
                                setOperatorAnd(newOperator)
                                onChange({
                                    ...value,
                                    triggerSpeed: getOdometerUnitValue(newSpeed, true),
                                    operatorAnd: newOperator
                                })
                            }}

                        />
                        {
                            triggerSpeed > 0 &&
                            <div style={{ width: "100%" }}>
                                <Slider
                                    min={getOdometerUnitValue(3)}
                                    max={getOdometerUnitValue(120)}
                                    sliderOneColor={false}
                                    showValue
                                    measure={odometerMeasure}
                                    valueLabelDisplay={'off'}
                                    value={Number(triggerSpeed)}
                                    onChange={(event) => {
                                        setTriggerSpeed(event)
                                        onChange({
                                            ...value,
                                            triggerSpeed: getOdometerUnitValue(event, true)
                                        })
                                    }}
                                />
                            </div>
                        }
                    </div>

                    {
                        ((triggerSpeed > 0) && (triggerPostedSpeed > 0))
                        &&
                        <div style={{ paddingTop: "20px", width: "100%" }}>
                            <Grid container direction="row" alignItems={'center'} spacing={1} color="primary" aria-label="outlined primary button group">
                                <Grid item sm={6}>
                                    <Pill
                                        textField={'name'}
                                        item={{ id: "AND", name: messages["alertsNewAlert_postedSpeed_operator_And"] }}
                                        outlined={operatorAnd != "True"}
                                        onClick={() => {
                                            setOperatorAnd("True")
                                            onChange({ ...value, operatorAnd: "True" })
                                        }}
                                        style={{ border: '0', margin: '2px 0', width: '100%' }}
                                        label="pill-label-text"
                                        colorField="default"
                                        colorSelection="005bf8"
                                    />
                                </Grid>
                                <Grid item sm={6}>
                                    <Pill
                                        textField={'name'}
                                        item={{ id: "OR", name: messages["alertsNewAlert_postedSpeed_operator_Or"] }}
                                        outlined={operatorAnd != "False"}
                                        onClick={() => {
                                            setOperatorAnd("False")
                                            onChange({ ...value, operatorAnd: "False" })
                                        }}
                                        style={{ border: '0', margin: '2px 0', width: '100%' }}
                                        label="pill-label-text"
                                        colorField="default"
                                        colorSelection="005bf8"
                                    />
                                </Grid>
                            </Grid>
                        </div>
                    }


                    <div style={{ paddingTop: "20px", width: "100%" }}>
                        <ToggleSwitch
                            id="triggerPostedSpeed"
                            small
                            blueToggle
                            optionLabels={["", ""]}
                            label={messages['alertsNewAlert_postedSpeed']}
                            checked={(triggerPostedSpeed > 0) ? true : false}
                            onChange={(event) => {
                                const newPostedSpeed = event ? 1 : 0
                                setTriggerPostedSpeed(newPostedSpeed)
                                const newOperator = !event ? "True" : operatorAnd
                                setOperatorAnd(newOperator)
                                onChange({
                                    ...value,
                                    triggerPostedSpeed: getOdometerUnitValue(newPostedSpeed, true),
                                    operatorAnd: newOperator
                                })
                            }}
                        />

                        {
                            triggerPostedSpeed > 0 &&
                            <div style={{ width: "100%" }}>
                                <Slider
                                    min={getOdometerUnitValue(1)}
                                    max={getOdometerUnitValue(50)}
                                    sliderOneColor={false}
                                    showValue
                                    measure={odometerMeasure}
                                    valueLabelDisplay={'off'}
                                    value={Number(triggerPostedSpeed)}
                                    onChange={(event) => {
                                        setTriggerPostedSpeed(event)
                                        onChange({
                                            ...value,
                                            triggerPostedSpeed: getOdometerUnitValue(event, true)
                                        })
                                    }}
                                />
                            </div>
                        }


                    </div>
                    {
                        units?.some(item => item?.manufacturerName === "CerebrumX") &&
                        <div>
                             <div style={{ paddingTop: "20px", width: "100%" }}>
                                <label className="input-normal-label">{messages['alertsNewAlert_triggerValidationOem']}</label>
                            </div>
                            <div style={{ paddingTop: "20px", width: "100%" }}>
                                <ToggleSwitch
                                    id="triggerPostedSpeedOem"
                                    small
                                    blueToggle
                                    optionLabels={["", ""]}
                                    label={messages['alertsNewAlert_postedSpeedOem']}
                                    checked={(triggerPostedSpeedOem > 0) ? true : false}
                                    onChange={(event) => {
                                        const newValue = event ? 1 : 0
                                        setTriggerPostedSpeedOem(newValue)
                                        onChange({
                                            ...value,
                                            triggerOEMSpeeding: newValue ? true : false
                                        })
                                    }}
                                />
                            </div>
                        </div>
                    }
                    <Grid item style={{paddingTop:10}}>
                        <TriggerLandmark config={value} triggers={triggers} triggersRaw={triggersRaw} onChange={onChange} showErrorTrigger={showErrorTrigger}/>
                    </Grid>
                </div>
            }
        </Form>
    );
}
